import DeleteTasksConfirmationDialog from "./DeleteTasksConfirmationDialog";
import messageResource from '../../messageResource'

export default class DeleteTaskPopupConfirmationDialog extends DeleteTasksConfirmationDialog {
    constructor($container, cancelHandler, deleteHandler) {
        super($container, cancelHandler, deleteHandler);
    }

    createBlockedEntitiesList()
    {
        // do nothing
    }

    titleText()
    {
        return messageResource.getMessage("task.edit_popup.about_to_delete", [this.state.entityName]);
    }
}


// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/DeleteTaskPopupConfirmationDialog.js